import React, { useEffect, useRef, useState } from 'react';
import { UserContext } from '../../shared/authentication';
import { Link } from '../../shared/components';
import GlobalizedText from '../../shared/globalization';
import { $, ajax, getContextPath, getFromStorage, removeFromStorage, win } from '../../shared/utils';
import logo from './images/CXFusionEmpowerlogo_color_large.png';
import Menu from './menu';

function LoginButton(props: any) {
    if (props.user !== null) {
        return <></>;
    }
    return <Link to={"/login"} forceRefresh={true} className="btn-utility btn-uti-l"><GlobalizedText message="common.lbl.login" /></Link>;
}
function LogoutButton(props: any) {
    const config = getFromStorage('gwp.config', true);

    if (props.user === null) {
        return <></>;
    }
    if(config.openIdConnect === false){
        return <Link to="/login" onClick={() => {
            removeFromStorage('_csrf');
            props.userService.signout();
            if(config.openIdConnect === false){
                updateRegButtonState((showButton: boolean) => {
                    props.setShowRegistrationButton(showButton);
                });
            }
        }} className="btn-utility btn-uti-l"><GlobalizedText message="common.lbl.logout" /></Link>;
    }else{
        return <a href="javascript:void(0);" onClick={() => {
            removeFromStorage('_csrf');
            props.userService.signout(props.user.proxyUser);
        }} className="btn-utility btn-uti-l"><GlobalizedText message="common.lbl.logout" /></a>;
    }
}
function RegistrationButton(props: any) {
    if (props.user !== null) {
        return <></>;
    }
    return <Link to={"/registration"} forceRefresh={true} className="btn-utility btn-uti-l"><span><GlobalizedText message="login.lbl.signup" /></span></Link>;
}

function Name(props: any) {
    if (props.user === null) {
        return <></>;
    }
    return <Link to="/myprofile" className="u-split">{props.user.firstName} {props.user.lastName}</Link>
}

function Search(props: any) {
    return <></>
    /*<form className="gwp-header-collaps-search" action=".">
    <input value="searchCenter:query" name="uri" type="hidden" />
    <input type="hidden" name="contentNode" value="com.concentrix.webportal.search" />
    <input type="hidden" name="layoutNode" value="com.concentrix.webportal.Search Portlet Window" />
    <div className="input-group">
        <input type="text" className="form-control form-search" name="query" placeholder="Search..." />
        <span className="input-group-btn">
            <button className="btn btn-default form-search" type="button">
                <span className="glyphicon glyphicon-search" aria-hidden="true"></span>
            </button>
        </span>
    </div>
</form>*/
}

export function adjustHeaderHeight() {
    if ($(win).width() < 768) {
        $(".gwp-portlet-container").css("margin-top", ($("header").height() + "px"));
        $("#root>.gwp-page-content").css("margin-top", ($("header").height() + "px"));
    } else {
        $(".gwp-portlet-container").css("margin-top", "");
        $("#root>.gwp-page-content").css("margin-top", "");
    }
}

export function autoAdjustHeaderHeight() {
    $(win).on("resize", (e: any) => {
        adjustHeaderHeight();
    })
}

export function updateRegButtonState(callback: (showButton: boolean) => void) {
    ajax({
        url: '/api/registrationSingle/showRegistrationButton',
        success: (viewConfig) => {
            callback(viewConfig);
        }
    });
}

export function Header(props: any) {
    const timer = useRef<any>(undefined);
    const config = getFromStorage('gwp.config', true);
    const [showRegistrationButton, setShowRegistrationButton] = useState<boolean>(false);
    const [showLogoutButton, setShowLogoutButton] = useState<boolean>(false);
    useEffect(() => {
        if (timer.current === undefined) {
            timer.current = win.setInterval(() => {
                if ($("header").height() !== 0) {
                    adjustHeaderHeight();
                    if (timer.current !== undefined) {
                        win.clearInterval(timer.current);
                    }
                }
            }, 10);
            autoAdjustHeaderHeight();
            updateRegButtonState((showBtn: boolean) => {
                setShowRegistrationButton(showBtn);
            });
        }
    })

    useEffect(() => {
	    setTimeout(()=>{
			setShowLogoutButton(true);
		},2000);
    })
    const TwitterImage = () => {
        useEffect(() => {
            const img = document.querySelector('.twitter-img');
            const addHoverClass = () => img?.classList.add('twitter-img-hover');
            const removeHoverClass = () => img?.classList.remove('twitter-img-hover');
            img?.addEventListener('mouseover', addHoverClass);
            img?.addEventListener('mouseout', removeHoverClass);
        }, []);
        return(
            <a className="u-split hidden-xs hidden-sm" href="http://www.twitter.com"><img className='twitter-img' src={getContextPath() + "/static/themes/blue/images/x_logo.png"} alt='' /><div className="hidden">twitter</div></a>
        );
    };

    return (
        <header className="gwp-header">
            <div className="gwp-header-logobar">
                <div className="container ">
                    <div className="navbar-uptop">
                        <div className="nav-container">
                            <div className="navbar-logo">
                                <a rel="noopener noreferrer" ><img src={logo} /></a>
                            </div>
                            <div className="navbar-utility">
                                <a id="theme_submit_inquiry_header" data-toggle="modal" data-target="#theme_inquiry_popup" title="" href='#root'><GlobalizedText message="common.lbl.submitInq" /></a>
                                <UserContext.Consumer>
                                    {user => (
                                        <Name user={user} />
                                    )}
                                </UserContext.Consumer>
                                <a className="u-split u-social hidden-xs hidden-sm" href="http://www.facebook.com"><span className="u-facebook"></span><div className="hidden">facebook</div></a>
                                <a className="u-split u-social hidden-xs hidden-sm" href="http://www.twitter.com"><span className="u-twitter"></span><div className="hidden">twitter</div></a>
                                <UserContext.Consumer>
                                    {user => (
                                        <React.Fragment>
                                            {
                                                /*<SSOButton user={user} />*/
                                            }
                                            <LoginButton user={user} userService={props.userService} />
                                            { showLogoutButton && <LogoutButton user={user} userService={props.userService} />}
                                            {
                                                showRegistrationButton === true && <>
                                                    <RegistrationButton user={user} />
                                                </>}
                                        </React.Fragment>
                                    )}
                                </UserContext.Consumer>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div className="container gwp-header-menubar">
                <div className="gwp-header-menubar-header hidden-sm hidden-md hidden-lg">
                    <div className="row">
                        <div className="col-xs-9">
                            <Search />
                        </div>


                        <div className="col-xs-3">
                            <button type="button" className="navbar-toggle collapsed" onClick={() => { $("#navbar").collapse('toggle') }} aria-expanded="false" aria-controls="navbar">
                                <span className="sr-only">Toggle navigation</span>
                                <span className="icon-bar"></span>
                                <span className="icon-bar"></span>
                                <span className="icon-bar"></span>
                            </button>
                        </div>
                    </div>
                </div>

                <div id="navbar" className="collapse navbar-collapse gwp-header-menubar-body">
                    <div className="row">
                        <Menu breadcrumb={props.breadcrumb} />
                        <div className="col-md-4 col-sm-5 hidden-xs">
                            <Search />
                        </div>
                    </div>
                </div>
            </div>
        </header>
    );
}